import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class DeleteProfilePhotoApi {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async deleteProfilePhoto(userId: string, profileIndex: number) {

        try {

            if (!userId) {
                return {
                    statusCode: 404,
                    errormessage: "UserId is missing!"
                }
            }

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.post(
                `${this.authClient.getApiRoot()}/userProfile/deletePicture/${userId}/${profileIndex}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: ""
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage
            }
        }
    }
}

export default DeleteProfilePhotoApi;
